<template>
  <QuizJoinGameForm v-if="isShowFormJoinGame" class="padding spinner-wheel_form-join-game" />

  <div
    class="padding text-center"
    :class="{'white': $store.state.slide.textColour == '#ffffff'}"
    v-else
  >
    <div v-if="$store.state.slide.title || $store.state.slide.titleDesc">
      <h2
        class="title slide-title-style mt-0"
        :inner-html.prop="$store.state.slide.title | sanitize(true)"
      />
      <p
        class="subheading mb-3 word-pre"
        :inner-html.prop="$store.state.slide.titleDesc | sanitize(true)"
      />
    </div>

    <SpinnerWheelWaiting v-if="showWaitingSpinnerWheel()" />

    <SpinnerWheelResult v-else />

    <!-- Reactions -->
    <Reaction />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Reaction from '@/components/Reaction.vue'
import SpinnerWheelWaiting from '@/components/types/spinner-wheel/SpinnerWheelWaiting.vue'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'
import SpinnerWheelResult from '@/components/types/spinner-wheel/SpinnerWheelResult.vue'

export default {
  components: {
    Reaction,
    SpinnerWheelWaiting,
    QuizJoinGameForm,
    SpinnerWheelResult,
  },
  props: {
    isShowFormJoinGame: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,
    }),
  },
  methods: {
    showWaitingSpinnerWheel() {
      if (!this.slide.metadata) return true
      if (!this.slide.metadata.wheelStatus || this.slide.metadata.wheelStatus === 'spinning') return true
      if (!this.slide.metadata.winner) return true
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.text-center {
  text-align: center;
}

.padding {
  padding: 0 16px;
}

.title {
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 0;
}
.audio-control-slide {
  margin-top: 18px;
}

.spinner-wheel_waiting {
  max-width: 390px;
  position: relative;
  margin: 0 auto;
  margin-bottom: 60px;
  overflow: hidden;
}

.spinner-wheel_wheel {
  width: 100%;
  animation: spin 15s linear infinite;
}

.spinner-wheel_pointer {
  position: absolute;
  top: 5px;
  left: 55px;
  z-index: 1;
}

.spinner-wheel_box {
  background: #FFFFFF;
  box-shadow: 0px 5.5142px 5.5142px rgba(0, 0, 0, 0.05);
  border-radius: 14px;
  color: #333;
  text-align: center;
  position: absolute;
  top: 50%;
  width: 100%;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.4;
  transform: translateY(-50%);
}

.spinner-wheel_form-join-game {
  margin-bottom: 16px;
}

.word-pre {
  word-wrap: break-word;
}
</style>
